'use client';
import { isFunction } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Возвращает функцию-reducer для стилизации различных состояний компонента
 * @param state текущее состояние
 * @returns CSSObject соответственно состоянию
 *
 * @example
 * ```ts
 * const reduceState = stylesReducer(state)
 * const styles = reduceState(
 *  {
 *    background: 'green'
 *  },
 *  {
 *    disabled: { background: 'gray' }
 *  }
 * )
 * ```
 */ const stylesReducer = (state)=>{
    return (defaultValue, states)=>{
        if (state && state in states) {
            if (defaultValue) {
                return _extends({}, defaultValue, states[state]);
            }
            const result = states[state];
            return isFunction(result) ? result() : result;
        }
        return defaultValue || {};
    };
};

export { stylesReducer };
//# sourceMappingURL=stylesReducer.js.map
